// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1c6Ou","header":"Messages_header__TLfSr"};